import { LazyLoad } from '@petconsole/pure-fe-mui';

const ShopAdmin = LazyLoad(() => import('./ShopAdmin'));

export { ShopAdmin };
